"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const LayoutIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 4.5A4.5 4.5 0 014.5 0h7A4.5 4.5 0 0116 4.5v7a4.5 4.5 0 01-4.5 4.5h-7A4.5 4.5 0 010 11.5v-7zM4.5 2A2.5 2.5 0 002 4.5v7A2.5 2.5 0 004.5 14H7V2H4.5zM9 2v5h5V4.5A2.5 2.5 0 0011.5 2H9zm5 7H9v5h2.5a2.5 2.5 0 002.5-2.5V9z",
    clipRule: "evenodd"
  })))
});
LayoutIcon.displayName = 'LayoutIcon';
var _default = exports.default = LayoutIcon;